import React from "react";
import { Help } from "../../utils";
import { ProgressSpinner } from "primereact/progressspinner";
import { useSelector } from "react-redux";
export default function BlocStatistiques({ dataInfo }) {
  return (
    <>
      <section className="d-flex gap-3 align-items-center flex-wrap justify-content-center">
        {dataInfo.map((info, index) => (
          <SectionStat
            key={index}
            libelle={info.libelle}
            chiffreTotal={info.totalValue}
            icone={info.icone}
          />
        ))}
      </section>
    </>
  );
}

const SectionStat = ({ libelle, icone, chiffreTotal }) => {
  const showLoading = useSelector((state) => state.spinnerReducer.isLoading);
  const isMontant = {
    Prévisions: true,
    Revenus: true,
    Recouvrement: true,
  };
  return (
    <div className="sub-dashboard">
      <div className="d-flex align-items-center justify-content-center gap-2 my-2 px-5">
        <span>{icone}</span>
        <h6 className="my-2">{libelle}</h6>
      </div>
      {showLoading ? (
        <h2 className="fw-bold text-center">
          <ProgressSpinner style={{ width: "30px", height: "30px" }} />
        </h2>
      ) : (
        <h2 className="fw-bold text-center">
          {Help.convertInMoney(chiffreTotal)}
          {isMontant[libelle] && <span style={{ fontSize: ".5em" }}>Fcfa</span>}
        </h2>
      )}
    </div>
  );
};
